import { Component, OnInit } from '@angular/core';
import { SpinnerGeneralService } from './spinner-general.service';

@Component({
  selector: 'slt-spinner-general',
  templateUrl: './spinner-general.component.html',
  styleUrls: ['./spinner-general.component.scss']
})
export class SpinnerGeneralComponent implements OnInit {

  isLoading = false;

  constructor(private _spinnerService: SpinnerGeneralService) { }

  ngOnInit(): void {
    this._spinnerService.loadingStatus.subscribe(status => {
      this.isLoading = status;
    });
  }

}
